import { MAX_LIST_VISIBLE_INDENTATION, normalizeOffset } from 'wix-rich-content-common';

function getStartMargin(parentNode, visibleIndentation) {
  var _a, _b;
  if (!parentNode) {
    return "1.5em";
  }
  const parenNodeDataName = `${(_a = parentNode == null ? void 0 : parentNode.type) == null ? void 0 : _a.slice(0, -5).toLowerCase()}ListData`;
  const nodeOffset = ((_b = parentNode[parenNodeDataName]) == null ? void 0 : _b.offset) || 0;
  const offset = visibleIndentation > MAX_LIST_VISIBLE_INDENTATION ? nodeOffset - (visibleIndentation - MAX_LIST_VISIBLE_INDENTATION) : normalizeOffset(nodeOffset);
  return parentNode ? `${normalizeOffset(offset) * 2 + 1.5}em` : "";
}

export { getStartMargin };
//# sourceMappingURL=getStartMargin.js.map
